<template lang="pug">
div
  section.lazy-work(:class="{'u-mt-md': !work.styles || !work.styles.length || (work.styles.length === 1 && work.styles[0].class === 'is-dark' ) }")
    Content
      div(v-html="work.body")

  .u-mb-md
  section.u-mt-md
    AppTitle.u-mb-xs(:title="$t('works')")

    Query(
      :query="require('~/graphql/Work.gql').Works"
      :limit="10"
      :initialValue="works"
      :variables="({ first, after }) => ({ first, after, excluded: [work.id] })"
      :refetchOnRouteChange="true"
      v-slot="{ items }"
    )
      AsymetricGrid( :items="items" ref="grid" v-slot="{ item, ratio }")
        AppCard.is-work(:img="[{ srcset: item.thumb, type: 'image/jpg', ratio }]" :ratio="ratio" :title="item.title" :url="`/work/${item.slug}`")

  .u-mb-mi
</template>

<script>
import { generateContentSeo } from '~/utils/seo';
import { Work, Works } from '~/graphql/Work.gql';
import Query from '~/components/Query';
import AsymetricGrid from '~/components/PsudoRandomGrid';
import Content from '~/components/Content';

export default {
  scrollToTop: true,
  i18nLocaleRoot: '/work',
  transition: {
    name: 'bounce'
  },
  meta: {
    logoText: 'work'
  },
  head() {
    return generateContentSeo(this.work);
  },
  components: {
    Query,
    AsymetricGrid,
    Content
  },
  async asyncData({ app, params, error }) {
    try {
      const { data } = await app.$api.query({
        variables: { slug: params.slug },
        query: Work
      });

      if (!data.work) {
        return error({
          statusCode: 404,
          message: 'WORK_NOT_FOUND'
        });
      }

      const {
        data: { works }
      } = await app.$api.query({
        query: Works,
        variables: {
          first: 2,
          excluded: [data.work.id]
        }
      });

      app.applyContentTheme(data.work);
      app.verifyContentLocale(data.work);

      return {
        work: data.work,
        works
      };
    } catch (err) {
      error({
        statusCode: 500,
        message: err.message
      });
    }
  },
  data: () => ({
    loaded: false
  }),

  created() {
    this.work.content = this.work.body.replace(/\ssrc/g, ' data-src');
  },
  mounted() {
    setTimeout(() => {
      this.loaded = true;
    }, 500);

    // create config object: rootMargin and threshold
    // are two properties exposed by the interface
    const config = {
      rootMargin: '0px 0px 200px 0px',
      threshold: 0
    };

    // register the config object with an instance
    // of intersectionObserver
    let observer = new IntersectionObserver(function(entries, self) {
      // iterate over each entry
      entries.forEach(entry => {
        // process just the images that are intersecting.
        // isIntersecting is a property exposed by the interface
        if (entry.isIntersecting) {
          // custom function that copies the path to the img
          // from data-src to src
          const el = entry.target;
          el.setAttribute('src', el.getAttribute('data-src'));
          el.classList.add('is-loaded');
          // entry.target.removeAttribute('data-src');

          // the image is now in place, stop watching
          self.unobserve(entry.target);
        }
      });
    }, config);
    this.$nextTick(() => {
      const imgs = document.querySelectorAll('[data-src]');
      imgs.forEach(img => {
        observer.observe(img);
      });
    });
  },
  watch: {
    $route() {
      window.scroll({
        top: 0,
        left: 0
      });
    }
  },

  methods: {}
};
</script>

<style lang="stylus">
body[works]
  footer
    border: 0

// .lazy-work
//   .align-figure.is-full
//     .align-image
//       min-height: calc(100vh + 220px)
</style>

<i18n>
{
  "en": {
    "works":"More work"
  },
  "ar": {
    "works":"أعمال أكثر"
  }
}
</i18n>
